<p>{{ 'smart-id-login.verification-transaction.description' | translate }}</p>
<form>
	<span class="ico-smart-id-logo"></span>
	<ng-container *ngFor="let formControl of verificationFormArray?.controls; let i = index">
		<input matInput type="tel" maxlength="1" class="pin" [formControl]="formControl" autocomplete="off" required />
	</ng-container>
</form>
<mat-spinner diameter="35"></mat-spinner>
<div class="obg-m-smart-id-cancel">
	<a (click)="submitCancel()" class="cancel-button">{{ 'general.cancel' | translate }}</a>
</div>
